import React from "react";
import contact from "../../images/undraw_Contract_re_ves9.svg";
const Contact = () => {
  return (
    <div className="pt-32 grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 sm:px-2 sm:mx-2">
      <div className="flex justify-center">
        <img className="w-2/4" src={contact} alt="" />
      </div>
      <div className="flex justify-center">
        <div className="w-full max-w-xs">
          <h1 className="text-2xl font-bold title-design pb-4">Contact US</h1>
          <form className="bg-white shadow-md border-2 hover:shadow-2xl rounded-lg px-8 pt-6 pb-8 mb-4">
            <div className="mb-4">
              <label
                htmlFor="username"
                className="block text-gray-700 text-sm font-bold mb-2"
                for="username"
              >
                Username
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="email"
                className="block text-gray-700 text-sm font-bold mb-2"
                for="email"
              >
                Email
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                type="email"
              />

              <label
                htmlFor="message"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                Write Message
              </label>
              <textarea
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="write your message here"
                id=""
                cols="30"
                rows="5"
              ></textarea>
            </div>
            <div className="flex items-center justify-center">
              <button
                class="btn-design  hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                type="button"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
